var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-panel"},[_c('section',{staticClass:"mc-panel__box"},[_c('header',[_vm._t("header")],2),_vm._v(" "),_c('article',{staticClass:"mc-panel__scroll"},[_vm._t("default")],2),_vm._v(" "),_c('footer',[_vm._t("footer")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-panel.vue